import { Environment } from 'src/environments/environment.model';
import { parseLayerEnvironment } from 'src/environments/parse-environment';

// Deployment hosts provide tenant identity when runtime config is unavailable.
export const tenantHosts: Record<string, string> = {
  'layer.c4htest.mcps.agrifirm.com': 'Agrifirm',
  'layer.staging.mcps.agrifirm.com': 'Agrifirm',
  'layer.agrifirm.com': 'Agrifirm',
  'layer-agravis.c4htest.mcps.agrifirm.com': 'Agravis',
  'layer-agravis.staging.mcps.agrifirm.com': 'Agravis',
  'legehenne.avidata-agravis.de': 'Agravis',
};

export async function loadRuntimeEnvironment(
  buildEnvironment: Environment,
  hostname: string,
  buildId?: string,
  fetchConfig: typeof fetch = fetch,
): Promise<Environment> {
  const fallback = {
    ...buildEnvironment,
    TENANT: Object.prototype.hasOwnProperty.call(tenantHosts, hostname.toLowerCase())
      ? tenantHosts[hostname.toLowerCase()]
      : buildEnvironment.TENANT,
  };
  try {
    const configUrl = buildId ? `/assets/config.json?v=${buildId}` : '/assets/config.json';
    const response = await fetchConfig(configUrl, { cache: 'no-store' });
    if (response.ok) {
      const config = parseLayerEnvironment(await response.json());
      return { ...fallback, ...config, TENANT: config.TENANT ?? fallback.TENANT };
    }
    console.warn('No runtime configuration found, using default environment settings.');
  } catch (error) {
    console.warn('Failed to load runtime environment variables', error);
  }
  return fallback;
}
